import { Injectable } from '@angular/core';

import { CamLazyTranslationService } from '@camelot/translation';

@Injectable({
  providedIn: 'root',
})
export class AppTranslationService extends CamLazyTranslationService {
  constructor() {
    super('lancelot', true);
  }
}
